import { Box, useTheme } from "@mui/material";
import FooterView from "./footerView";

const FooterLayout = ({needCloudTop=true}) => {
    const theme = useTheme();

    return (
        <>
            {/* Cloud */}
            {/* <Box
                sx={{
                    width: '100%',
                    zIndex: 1,
                    backgroundColor: theme.palette.primary.main,
                    transform: 'scaleY(-1)',
                    display: needCloudTop ? 'block' : 'none'
                }}
            >
                <img 
                    src='/images/vectors/wave bg 2.png' 
                    alt='cloud' 
                    width='100%' 
                    style={{
                        transform: 'translateY(6px)'
                    }}
                />
            </Box> */}

            <FooterView />
        </>
    );
}

export default FooterLayout;